<template>
  <base-show :fields="isProvider ? adminFields: makerFields" :resourceName="resourceName" :pk="pk" :breadcrumbs="breadcrumbs"
             @check-maker="checkMaker">
    <template v-slot:actions.remove>
      <span v-if="authAccountId === pk" />
    </template>
    <template slot="published_status" slot-scope="{ input }">
      <span >{{input === 1 ? "公開" :　
                      ( input === 2 ? "非公開予約" : (
                            input === 3 ? "公開予約"
                                : "非公開"))}}
                </span>
    </template>
    <template slot="user_plan_only" slot-scope="{ input }">
      <span >{{input === 1 ? "会員限定である" : "会員限定でない" }}
                </span>
    </template>
    <template slot="apply_at" slot-scope="{ input }">
      <span>{{input && "予約日時:" + input}}</span>
    </template>
    <template slot="materials" slot-scope="{ input }">
      <CListGroup>
      <CListGroupItem v-for="(material, index) in input" :key="index"
      style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px">名称：{{material['name']}} / 量：{{material['amount']}} /  単位：{{material['unit']}}
      </CListGroupItem>
      </CListGroup>
    </template>
    <template slot="procedure" slot-scope="{ input }">
      <CListGroup>
        <CListGroupItem v-for="(procedure, index) in input" :key="'process' + index"
                        style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px">{{procedure}}
        </CListGroupItem>
      </CListGroup>
    </template>
    <template slot="product_ids" slot-scope="{ input }">
      <CListGroup>
        <CListGroupItem v-for="(id, index) in input" :key="'product' + index"
                        style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px">{{optionName("common/products", id)}}
        </CListGroupItem>
      </CListGroup>
    </template>
  </base-show>
</template>

<script>
export default {
  props: {
    pk: {
      type: String,
      required: true
    }
  },
  data() {
    const vm = this;
    const commonFields = [
      {
        label: "提供メーカー",
        name: "maker_id",
        optionType: "common/makers",
        render(value) {
          return vm.optionName("common/makers", value);
        },
        isProvider: true
      },
      {
        label: "システム管理レシピID",
        name: "recipe_id"
      },
      {
        label: "レシピID",
        name: "internal_recipe_id"
      },
      {
        label: "レシピ名",
        name: "dish_name"
      },
      {
        label: "レシピ名(かな)",
        name: "dish_name_kana"
      },
      {
        label: "一言説明",
        name: "description",
        long: true
      },
      {
        label: "レシピ画像",
        name: "images",
        type: "images",
        long: true
      },
      {
        label: "調理時間",
        name: "cooking_time",
        render(value) {
          return value + "分";
        }
      },
      {
        label: "カロリー",
        name: "calorie",
        render(value) {
          if (value !== "" && value !== null && value !== undefined) {
            return value.toLocaleString() + " カロリー";
          }
          return "";
        }
      },
      {
        label: "原価",
        name: "cost",
        render(value) {
          if (value !== "" && value !== null && value !== undefined) {
            return value.toLocaleString() + " 円";
          }
          return "";
        }
      },
      {
        label: "コツ／ポイント",
        name: "tips",
        long: true
      },
      {
        label: "紐付き商品",
        name: "product_ids",
        type: "custom"
      },
      {
        label: "商品メインフラグ",
        name: "main_product_id",
        optionType: "common/products",
        render(value) {
          return vm.optionName("common/products", value);
        }
      },
      {
        label: "材料",
        name: "materials",
        type: "custom"
      },
      {
        label: "調理手順",
        name: "procedure",
        long: true,
        type: "custom"
      },
      {
        label: "キーワード",
        name: "keywords"
      },
      {
        label: "レシピカテゴリ",
        name: "category",
        optionType: "common/recipe_categories",
        render(value) {
          return vm.optionName("common/recipe_categories", value);
        }
      },
      {
        label: "PV数",
        name: "pv",
        long: true
      },
      {
        label: "公開ステータス",
        name: "published_status",
        type: "custom"
      },
      {
        label: "会員限定フラグ",
        name: "user_plan_only",
        type: "custom"
      },
      {
        label: "",
        name: "apply_at",
        type: "custom"
      }
    ];
    return {
      resourceName: "recipes",
      adminFields: [commonFields],
      makerFields: [commonFields]
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "レシピ管理",
          disabled: false,
          to: `/${this.resourceName}`
        },
        {
          text: "レシピ詳細",
          disabled: true
        }
      ];
    },
    authAccountId() {
      return this.$store.getters[`auth/accountId`];
    },
    optionName() {
      return (optionName, value) => {
        const options =
          this.$store.getters[`${optionName}/options/options`] || [];
        return (options.find(v => v.value === value) || {}).label;
      };
    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    }
  },
  methods: {
    moveToUpdatePasswordView() {
      this.$router.push({
        path: `/${this.resourceName}/${this.pk}/edit/password`
      });
    },
    checkMaker(entity) {
      this.$router.push({ path: `/makers/${entity.maker_id}` });
    }
  }
};
</script>
